import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import { Box, Button, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getSmeLeads } from "../../../../redux/features/smeSlice";
import { SME_LEAD_TABLE_HEAD } from "../../../../components/datagrid/sme/smeLeads/SmeLeadsTableHead";
import Smedetailview from "./Smedetailview";
import SMEstatus from "./SmeStatus";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { filter } from "lodash";
import OGARemarks from "../../../crd/myworkspace/NewAdmissionRegister/components/OGAremarks";
import InduvidualAssessmentReport from "../../../assessmentReportInduvidual/InduvidualAssessmentReport";
import SubjectSession from "./SubjectSession";

const SMEleads = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { smeLeads, loading } = useSelector((state) => state.sme);

  const [value, setValue] = useState(dayjs());

  const data = {
    page: pageNum,
    limit: gridSize,
    filter: search,
    date: dayjs(value).format("YYYY-MM"),
  };

  useEffect(() => {
    if (pageNum) {
      dispatch(getSmeLeads(data));
    }
  }, [pageNum, gridSize, value, search]);

  return (
    <GlobalWrapper title={"SME Leads"}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", pb: 2 }}>
        <Stack direction={"row"} spacing={2}>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Year/Month"
                value={value}
                views={["year", "month"]}
                onChange={(newValue) => setValue(newValue)}
                format="YYYY-MM" //
              />
            </LocalizationProvider>
          </Box>
        </Stack>
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={SME_LEAD_TABLE_HEAD}
          rows={smeLeads.data}
          meta={smeLeads?.meta?.totalRecords || 0}
          rowUniqueId="sl_no"
          loading={loading}
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.name} />
              <GlobalAnchorList
                label={"Update Status"}
                component={<SMEstatus rowData={rowData} dispatchdata={data} />}
              />
              <GlobalAnchorList
                label={"OGA Remarks"}
                component={
                  <OGARemarks
                    CROAssignID={rowData?.cro_assignment_id}
                    name={rowData?.name}
                    classType={rowData?.class}
                    contactNumber={rowData?.contactNumber}
                    course={rowData?.assigned_course_name}
                  />
                }
              />
              <GlobalAnchorList
                label={"Subject & Session"}
                component={
                  <SubjectSession
                    courseEnrollmentId={rowData?.course_enrollment_id}
                  />
                }
              />
              <GlobalAnchorList
                component={
                  <Box>
                    <Button
                      sx={{
                        p: "7px",
                        px: "10px",
                        background:
                          "linear-gradient(135deg, rgba(55, 22, 58, 1), rgba(88, 23, 75, 1))",
                        color: "#fff",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, rgba(229, 64, 241, 0.79), rgba(168, 47, 199, 0.74))",
                        },
                      }}
                      onClick={() =>
                        navigate(
                          `/my-workspace/academic-calendar?leadId=${rowData?.leadId}`
                        )
                      }
                    >
                      <Icon icon="bx:calendar" width="20" height="20" />
                      Academic Calendar
                    </Button>
                  </Box>
                }
              />
              <GlobalAnchorList
                component={
                  <InduvidualAssessmentReport
                    // disabled={rowData?.assessment_report_file_exists != 1}
                    sx={{
                      p: "7px",
                      background:
                        "linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(160, 37, 194, 0.74))",
                      color: "#fff",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, rgb(0, 49, 208), rgb(171, 37, 194))",
                      },
                    }}
                    leadId={rowData?.leadId}
                    buttonName={"Assessment Report"}
                    btnIcon={<Icon icon="mdi:eye" width="20" height="20" />}
                  />
                }
              />
              <GlobalAnchorList
                component={
                  <Box>
                    <Button
                      sx={{
                        p: "7px",
                        px: "10px",
                        background:
                          "linear-gradient(135deg, rgb(62, 72, 106), rgb(134, 105, 241))",
                        color: "#fff",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(62, 108, 177, 0.74))",
                        },
                      }}
                      onClick={() =>
                        navigate(
                          `/my-workspace/sme-topicschedules?courseenrollmentId=${rowData?.course_enrollment_id}&studentname=${rowData?.name}&phone=${rowData?.contactNumber}&course=${rowData?.assigned_course_name}`
                        )
                      }
                      variant="outlined"
                    >
                      <Icon
                        icon="healthicons:i-schedule-school-date-time"
                        width="20"
                        height="20"
                      />
                      Add Topic Schedule
                    </Button>
                  </Box>
                }
              />
              <GlobalAnchorList
                component={
                  <Box>
                    <Button
                      sx={{
                        p: "7px",
                        px: "10px",
                        gap: 1,
                        background:
                          "linear-gradient(135deg, rgb(62, 106, 81), rgb(105, 241, 164))",
                        color: "#fff",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, rgba(54, 117, 88, 0.79), rgba(57, 149, 72, 0.74))",
                        },
                      }}
                      onClick={() => {
                        const url =
                          "https://workspace.teaminterval.net/tutor/active/0";
                        window.open(url, "_blank");
                      }}
                    >
                      <Icon
                        icon="famicons:person-sharp"
                        width="20"
                        height="20"
                      />
                      Active Tutors
                    </Button>
                  </Box>
                }
              />
              <GlobalAnchorList
                component={
                  <Box>
                    <Button
                      sx={{
                        p: "7px",
                        px: "10px",
                        gap: 1,
                        background:
                          "linear-gradient(135deg, rgb(107, 65, 127), rgb(152, 67, 153))",
                        color: "#fff",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, rgba(139, 84, 111, 0.79), rgba(150, 34, 115, 0.74))",
                        },
                      }}
                      onClick={() => {
                        const urlmaterial =
                          "https://workspace.teaminterval.net/material/index";
                        window.open(urlmaterial, "_blank");
                      }}
                    >
                      <Icon
                        icon="emojione-monotone:closed-book"
                        width="20"
                        height="20"
                      />
                      Study Materials
                    </Button>
                  </Box>
                }
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default SMEleads;
